export default () => (
  /**
   * Icone de uma prancheta.
   * Responsavel por editar coordenadas.
   * Encontrado no menu de inserir coordenadas.
   */
  <svg
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.22168 6.58984C2.94554 6.58984 2.72168 6.8137 2.72168 7.08984C2.72168 7.36599 2.94554 7.58984 3.22168 7.58984V6.58984ZM9.56407 7.58984C9.84021 7.58984 10.0641 7.36599 10.0641 7.08984C10.0641 6.8137 9.84021 6.58984 9.56407 6.58984V7.58984ZM3.22168 7.58984H9.56407V6.58984H3.22168V7.58984Z"
      fill="#BEC7DC"
    />
    <path
      d="M3.22168 9.99805C2.94554 9.99805 2.72168 10.2219 2.72168 10.498C2.72168 10.7742 2.94554 10.998 3.22168 10.998V9.99805ZM9.56407 10.998C9.84021 10.998 10.0641 10.7742 10.0641 10.498C10.0641 10.2219 9.84021 9.99805 9.56407 9.99805V10.998ZM3.22168 10.998H9.56407V9.99805H3.22168V10.998Z"
      fill="#BEC7DC"
    />
    <path
      d="M3.22168 13.4062C2.94554 13.4062 2.72168 13.6301 2.72168 13.9062C2.72168 14.1824 2.94554 14.4062 3.22168 14.4062V13.4062ZM9.56407 14.4062C9.84021 14.4062 10.0641 14.1824 10.0641 13.9062C10.0641 13.6301 9.84021 13.4062 9.56407 13.4062V14.4062ZM3.22168 14.4062H9.56407V13.4062H3.22168V14.4062Z"
      fill="#BEC7DC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.06568 1.95194C7.06558 1.95235 7.06549 1.95276 7.0654 1.95317V2.05957C7.07416 2.222 7.12278 2.3637 7.39542 2.38872H7.97678C7.98254 2.3729 7.98808 2.35698 7.99341 2.34094H8.56406V3.72059H4.22148V2.34094H4.7925C4.79783 2.35698 4.80337 2.3729 4.80913 2.38872H5.39173C5.46962 2.38157 5.52923 2.3649 5.57484 2.34094H5.57536C5.71287 2.26858 5.72305 2.1299 5.7239 1.98639V1.55987C5.74364 1.47958 5.77476 1.40627 5.81456 1.34107H6.97135C7.01371 1.41046 7.04623 1.48902 7.06568 1.57542V1.95194ZM8.03724 1.34094H9.26406C9.42975 1.34094 9.56406 1.47526 9.56406 1.64094V2.15129H11.706C12.2583 2.15129 12.706 2.59901 12.706 3.15129V16C12.706 16.5523 12.2583 17 11.706 17H1.08008C0.527794 17 0.0800781 16.5523 0.0800781 16V3.15129C0.0800781 2.59901 0.527793 2.15129 1.08008 2.15129H3.22148V1.64094C3.22148 1.47526 3.3558 1.34094 3.52148 1.34094H4.74867C4.9305 0.571048 5.5977 0 6.39296 0C7.18821 0 7.85541 0.571048 8.03724 1.34094ZM5.81464 1.34094C5.94543 1.12678 6.16994 1 6.39296 1C6.61597 1 6.84048 1.12678 6.97127 1.34094H5.81464ZM3.22148 3.15129H1.08008V16L11.706 16V3.15129H9.56406V4.42059C9.56406 4.58627 9.42975 4.72059 9.26406 4.72059H3.52148C3.3558 4.72059 3.22148 4.58627 3.22148 4.42059V3.15129Z"
      fill="#BEC7DC"
    />
  </svg>
);
